import React from "react";
import { GetHeroImage } from "./profileLoader";

import { Image } from "semantic-ui-react";
import StatsTable from "./components/statsTable";

import { formatWinRate, sortByWinAndLoss } from "./utils";

type Props = {
  heroes: any;
};

const HeroTable = ({ heroes }: Props) => {

  const sortedHeroes = sortByWinAndLoss(heroes);

  if(sortedHeroes.length === 0) {
    return <></>
  }

  return (
    <StatsTable header={"Heroes"} leftColumn={"Hero"}>
      {sortedHeroes.map(([name, stats]) => (
        <tr key={name}>
          <td style={{ textAlign: "left" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1em",
              }}
            >
              <Image
                src={GetHeroImage(name)}
                alt={name}
                size="mini"
              />
              <p>
                {name}
              </p>
            </div>
          </td>
          <td>{stats.win_count}</td>
          <td>{stats.lose_count}</td>
          <td>{formatWinRate(stats.win_count, stats.lose_count)}</td>
        </tr>
      ))}
    </StatsTable>
  );
};
export default HeroTable;
